<script>
    import { getPosts } from "../getPosts.js";
    import { store } from "../store.js";

    async function updateSearch(input) {
        $store.options[$$props.id].loading = true;



        let params = new URLSearchParams($store.options[$$props.id].filtres).toString();

        let myPosts = await getPosts(params);
        $store.posts[$$props.id] = myPosts;
        $store.options[$$props.id].found_posts = myPosts.found_posts;
        $store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
        $store.options[$$props.id].loading = false;
    }

</script>

<div class="cs_search">
    <label>Votre recherche :</label> <input title="Rechercher" type="text" bind:value={$store.options[$$props.id].filtres.search}  on:input={updateSearch} />
</div>
